import Vue from "vue";
import Router from "vue-router";
import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import Notifications from "@/pages/Notifications.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Typography from "@/pages/Typography.vue";
import LoginPage from "@/pages/LoginPage.vue";

import { isUserActive } from "@/stores/auth.ts";

Vue.use(Router);

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/content",
    children: [
      {
        path: "content",
        name: "content",
        component: Dashboard,
      },
      {
        path: "registered",
        name: "registered",
        component: UserProfile,
      },
    ],
    beforeEnter: (to, from, next) => {
      if (!isUserActive() && to.path !== "/login") {
        next("/login");
      } else {
        next();
      }
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
    beforeEnter: (to, from, next) => {
      if (!isUserActive()) {
        next();
      } else {
        next("/content");
      }
    },
  },
  {
    path: "*",
    component: NotFound,
    redirect: "/content",
  },
];

export default routes;
